export default [{
  type: 'text',
  label: '普通文本',
  value: ''
}, {
  type: 'mobile',
  label: '手机号',
  value: '^[1][3,4,5,7,8,9][0-9]{9}$'
}, {
  type: 'tel',
  label: '电话号码',
  value: '^(0[0-9]{2,3}\\-)?([2-9][0-9]{6,7})+(\\-[0-9]{1,4})?$'
}, {
  type: 'email',
  label: '邮箱',
  value: '^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$'
}, {
  type: 'integer',
  label: '整数',
  value: '^\\d+$'
}, {
  type: 'positive',
  label: '正整数',
  value: '^[1-9]\\d*$'
}, {
  type: 'natural',
  label: '自然数',
  value: '^[0-9]\\d*$'
}, {
  type: 'number',
  label: '数字(支持小数)',
  value: '^[0-9]+(.[0-9]{1,})?$'
}, {
  type: 'idcard',
  label: '身份证',
  value: '(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)'
}, {
  type: 'zip',
  label: '邮政编码',
  value: '^\\d{6}$'
}, {
  type: 'chinese',
  label: '中文',
  value: '^[\\u4e00-\\u9fa5]+$'
}, {
  type: 'money',
  label: '金额',
  value: '^(^[1-9](\\d+)?(\\.\\d{1,2})?$)|(^0$)|(^\\d\\.\\d{1,2}$)$'
}, {
  type: 'score',
  label: '分数',
  value: '^\\d+(\\.\\d{1,2})?$'
}];